import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-ayr-description',
    imports: [TranslateModule, RouterLink],
    templateUrl: './ayr-description.component.html',
    styleUrl: './ayr-description.component.scss'
})
export class AyrDescriptionComponent {}
